module.exports = __webpack_public_path__ + "static/media/DSC02460.804bb418.jpg";